import Carrier from '@/src/common/components/marketing/products/Carrier'
import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'
import GreetingCardWithFlip from '@/src/modules/build-a-card/physical/content/GreetingCardWithFlip'
import { styled } from '@/src/stitches.config'
import Image from 'next/image'

const GreetingCardWithEnvelopeWrapper = styled('div', {
    maxWidth: '100%',
    '.envelope': {
        position: 'absolute',
        width: '72%',
        maxWidth: 426,
        left: '21%',
        height: 'auto',
        opacity: 1,
        transition: 'opacity 300ms',
    },
})

interface IStep4Props {
    cloudinary: string
}

const Step4LeftContent = ({ cloudinary }: IStep4Props) => {
    const { hasGreetingCard, currentStep } = useBasicGiftCardContext()
    const isMessageStep = currentStep === 4
    const defaultPage = isMessageStep ? 1 : 0
    if (hasGreetingCard) {
        return (
            <>
                <h1 style={{ marginTop: 20 }}>
                    Choose a <span className={'gradient'}>cover design</span>
                </h1>
                <GreetingCardWithEnvelopeWrapper>
                    <Image
                        src={'/images/envelope.png'}
                        width={640}
                        height={425}
                        alt={'Greeting card envelope'}
                        data-testid={'greeting-card-envelope'}
                        className={'envelope'}
                        priority={true}
                    />
                    <GreetingCardWithFlip
                        displayPageButtons={true}
                        defaultPage={defaultPage}
                    />
                </GreetingCardWithEnvelopeWrapper>
            </>
        )
    }

    return (
        <>
            <h1 style={{ marginTop: 20 }}>
                Customize your <span className={'gradient'}>carrier</span>
            </h1>
            <Carrier cloudinary={cloudinary} />
        </>
    )
}

export default Step4LeftContent
